// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../Styles/ForgotPassword.css'
// import axios from 'axios';

// const ForgotPassword= () => {
//   const [email, setEmail] = useState('');
//   const [isVerificationSent, setIsVerificationSent] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const isValidEmail = (email) => {
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     return emailRegex.test(email);
//   };

//   const handleSendVerificationCode = async (e) => {
//     e.preventDefault();

//     if (!email || !isValidEmail(email)) {
//       setError('Please enter a valid email address');
//       return;
//     }

//     try {
//       const response = await axios.post(
//         'https://b2bbackend.dxbhabibi.com/api/b2/agency/sendOTP',
//         { email },
//         { headers: { 'Content-Type': 'application/json' } }
//       );

//       if (response.status === 200) {
//         setIsVerificationSent(true);
//         setError('');
//         alert('Verification code sent!');
//         navigate('/verify-code-admin', { state: { email } }); // assuming /verify-code-admin route exists
//       } else {
//         setError('Error sending verification code');
//       }
//     } catch (err) {
//       console.error(err);
//       setError('Failed to send verification code');
//     }
//   };

//   return (
//     <div className="forgot-password-container">
//       <div className="form-card">
//         <h2>Forgot Password (Agency)</h2>
//         <form onSubmit={handleSendVerificationCode}>
//           {!isVerificationSent && (
//             <>
//               <div className="form-group">
//                 <label>Email:</label>
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="Enter your email"
//                   required
//                 />
//               </div>
//               {error && <p className="error-text">{error}</p>}
//               <button type="submit" className="submit-button">Send Verification Code</button>
//             </>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from "../Images/LOGO1.png"; // adjust path if needed

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isVerificationSent, setIsVerificationSent] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSendVerificationCode = async (e) => {
    e.preventDefault();

    if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      const response = await axios.post(
        'https://b2bbackend.dxbhabibi.com/api/b2/agency/sendOTP',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        setIsVerificationSent(true);
        setError('');
        alert('Verification code sent!');
        navigate('/verify-code-admin', { state: { email } });
      } else {
        setError('Error sending verification code');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to send verification code');
    }
  };

  return (
    <div
      className="forgot-password-container"
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        background: '#f4f6f8'
      }}
    >
      {/* LOGO TOP LEFT */}
      <img
        src={logo}
        alt="Home"
        onClick={() => navigate('/')}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          height: '100px',
          cursor: 'pointer',
          objectFit: 'contain'
        }}
      />

      {/* FORM CARD */}
      <div
        className="form-card"
        style={{
          width: '100%',
          maxWidth: '420px',
          padding: '30px',
          borderRadius: '12px',
          background: '#ffffff',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            marginBottom: '20px',
            color: '#34495e'
          }}
        >
          Forgot Password (Agency)
        </h2>

        <form onSubmit={handleSendVerificationCode}>
          {!isVerificationSent && (
            <>
              <div
                className="form-group"
                style={{ marginBottom: '15px' }}
              >
                <label
                  style={{
                    display: 'block',
                    marginBottom: '6px',
                    fontWeight: '600'
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '6px',
                    border: '1px solid #ccc'
                  }}
                />
              </div>

              {error && (
                <p
                  className="error-text"
                  style={{
                    color: 'red',
                    textAlign: 'center',
                    marginBottom: '10px'
                  }}
                >
                  {error}
                </p>
              )}

              <button
                type="submit"
                className="submit-button"
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: '#1abc9c',
                  color: '#fff',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Send Verification Code
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
